import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCertificate,
  faDashboard,
  faList,
  faSignOut,
  faUserShield,
  faUsers,
  faCalendarAlt,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

export const Sidebar = () => {
  const navigate = useNavigate();
  function isAdmin() {
    const user = localStorage.getItem("user");
    if (user) {
      try {
        const userData = JSON.parse(user);
        return userData.role === "admin";
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  const adminUser = isAdmin();

  return (
    <>
      <div className="sidenav flex md:flex-col items-center md:items-start justify-between">
        <NavLink
          to="/dashboard"
          className="clickable-blue my-2"
        >
          <span className="text-3xl font-extrabold">Certification System</span>
        </NavLink>

        <div className="flex md:flex-col">
          {/* Common Routes */}
          <NavLink style={{ marginBottom: "0.5rem" }} to="/dashboard" className="">
            <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faDashboard} />
            <span className="hidden sm:block md:inline active">Dashboard</span>
          </NavLink>

          <NavLink style={{ marginBottom: "0.5rem" }} to="/my-certificates" className="">
            <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faCertificate} />
            <span className="hidden sm:block md:inline">My Certificates</span>
          </NavLink>

          <NavLink style={{ marginBottom: "0.5rem" }} to="/verify" className="">
            <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faCheckCircle} />
            <span className="hidden sm:block md:inline">Verify Certificate</span>
          </NavLink>

          {/* Admin Only Routes */}
          {adminUser && (
            <>
              <hr style={{ width: "100%", margin: "1rem 0" }} />
              <div style={{ marginBottom: "0.5rem", color: "#666", fontSize: "0.9em" }}>
                <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faUserShield} />
                <span className="hidden sm:block md:inline">Admin Panel</span>
              </div>

              <NavLink style={{ marginBottom: "0.5rem" }} to="/admin" className="">
                <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faUserShield} />
                <span className="hidden sm:block md:inline">Admin Dashboard</span>
              </NavLink>

              <NavLink style={{ marginBottom: "0.5rem" }} to="/categories" className="">
                <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faList} />
                <span className="hidden sm:block md:inline">Categories</span>
              </NavLink>

              <NavLink style={{ marginBottom: "0.5rem" }} to="/events" className="">
                <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faCalendarAlt} />
                <span className="hidden sm:block md:inline">Events</span>
              </NavLink>
            </>
          )}

          {/* Logout */}
          <hr style={{ width: "100%", margin: "1rem 0" }} />
          <NavLink style={{ marginBottom: "0.5rem" }} to="/logout" className="">
            <FontAwesomeIcon style={{ marginRight: "1rem" }} icon={faSignOut} />
            <span className="hidden sm:block md:inline">Logout</span>
          </NavLink>
        </div>
      </div>
    </>
  );
};
